/**
 * `health` procedure group — the one unauthenticated procedure in the oRPC surface.
 * (`GET /health` and `GET /ready` remain raw Hono handlers for the load balancer.)
 */

import { z } from 'zod';
import { isoDateTimeSchema } from './common.ts';

export const healthPingOutputSchema = z.object({
  ok: z.literal(true),
  /** Server clock, so a client can detect its own skew before signing DPoP proofs. */
  now: isoDateTimeSchema,
  /** The contract version this deployment implements. */
  contractVersion: z.string(),
});

export type HealthPingOutput = z.output<typeof healthPingOutputSchema>;
